exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-a480bd9e] .md-field.md-theme-default label {\r\n    top: -0.8rem !important;\r\n    font-size: 0.6875rem !important;\n}\n.member-options[data-v-a480bd9e] {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\n.empty {\r\n        width: 0px;\r\n        padding: 0;\r\n        margin: 0;\n}\n}\n.member-code[data-v-a480bd9e] {\r\n    font-size: 11px;\r\n    color: #666;\n}\r\n", ""]);

// exports
